/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * Frontend JS.
 */
var $ = require("jquery");
var Flickity = require('flickity');

if ($(window).width() < 768) {
    const flkty = new Flickity('.block-application .slider', {
        pageDots: true,
        prevNextButtons: false,
        cellAlign: 'center'
    });
}

else if ($(window).width() < 1199) {
    const flkty = new Flickity('.block-application .slider', {
        pageDots: true,
        prevNextButtons: false,
        cellAlign: 'left',
        contain: true
    });
}

// $( '.block-application .slider .slide').hover( function() {
//     $( '.block-application .slider .slide').removeClass('active');
//     $(this).addClass('active');
// })